import React from 'react';
import {withStyles} from "@material-ui/core/styles";
import createBreakpoints from '@material-ui/core/styles/createBreakpoints'
import { ThemeProvider, createTheme } from '@mui/material/styles';
import HeroImage from "../../../assets/productevent/hero_video.jpg";
import Button from "@mui/material/Button";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

const breakpoints = createBreakpoints({})

const muiTheme = createTheme({
    palette: {
        primary: {
            main: "#FF2E28",
        },
        secondary: {
            main: "#FFF",
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    padding: '0',
                    borderRadius: '4',
                    minWidth: '0',
                    width: '48px',
                    height: '40px',

                    [breakpoints.up('md')]: {
                        width: '72px',
                        height: '60px',
                    },
                }
            }
        },
    }
});

const useStyles = theme => ({
    videoPlayer: {
        position: 'relative',
        height: '192px',
        background: 'black',

        '& img': {
            width: '100%',
        },

        [theme.breakpoints.up('sm')]: {
            height: '272px',
        }
    },
    videoPlayBtn: {
        position: 'absolute',
        top: 'calc(50% - 20px)',
        left: 'calc(50% - 24px)',

        [theme.breakpoints.up('md')]: {
            top: 'calc(50% - 30px)',
            left: 'calc(50% - 36px)',
        }
    },
    svgIcons: {
        transform: 'scale(2)',

        [theme.breakpoints.up('md')]: {
            transform: 'scale(3)',
        }
    }
});

class VideoPlayerPanel extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showPlayBtn: true,
            showVideoControls: false
        }
    }

    componentDidMount() {
    }

    render() {
        const { classes } = this.props;
        let self = this;
        let videoElement = null;

        const handlePlay = () => {
            if (videoElement) {
                videoElement.play();
                self.setState({ showPlayBtn: false });
                self.setState({ showVideoControls: true });
            }
        };

        function PlayBtn() {
            if (self.state.showPlayBtn) {
                return (
                    <div className={classes.videoPlayBtn}><Button variant="contained" onClick={handlePlay}><PlayArrowIcon className={classes.svgIcons} size="large" /></Button></div>
                )
            }

            return (
                <div />
            )
        }

        return (
            <ThemeProvider theme={muiTheme}>

            <div className={classes.videoPlayer}>
                <video
                    ref={(node) => {
                        videoElement = node;
                    }}
                    src={"https://adelaidewingchunacademy.com.au/assets/WSDW_landscape.mp4"}
                    width="auto"
                    height="100%"
                    controls={self.state.showVideoControls}
                    poster={HeroImage}
                />
                <PlayBtn />
            </div>

            </ThemeProvider>
        )
    }
}

export default withStyles(useStyles)(VideoPlayerPanel)